export default __webpack_public_path__ + "1.18.3/static/media/sad-file.7129a039.svg";